// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1mcx8","right":"styles_right__3knD5"};